import { SALES_HUB_STARTER, SALES_HUB_PROFESSIONAL, SALES_HUB_ENTERPRISE, SERVICE_HUB_STARTER, SERVICE_HUB_PROFESSIONAL, SERVICE_HUB_ENTERPRISE, COMMERCE_HUB_PROFESSIONAL, COMMERCE_HUB_ENTERPRISE } from 'self-service-api/constants/ApiNames';
export const getApiNameForSeatType = (seatType, fallback) => {
  if (!seatType) return fallback;
  const seatString = String(seatType);
  const [hub, maybeTier] = seatString.split('-');
  const tier = maybeTier === 'pro' ? 'professional' : maybeTier;
  if (hub === 'sales') {
    if (tier === 'starter') return SALES_HUB_STARTER;
    if (tier === 'professional') return SALES_HUB_PROFESSIONAL;
    if (tier === 'enterprise') return SALES_HUB_ENTERPRISE;
  }
  if (hub === 'service') {
    if (tier === 'starter') return SERVICE_HUB_STARTER;
    if (tier === 'professional') return SERVICE_HUB_PROFESSIONAL;
    if (tier === 'enterprise') return SERVICE_HUB_ENTERPRISE;
  }
  if (hub === 'commerce') {
    if (tier === 'professional') return COMMERCE_HUB_PROFESSIONAL;
    if (tier === 'enterprise') return COMMERCE_HUB_ENTERPRISE;
  }
  return fallback;
};